export default "__VITE_ASSET__af2afb05__"